import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FormProvider, RHFTextField } from 'src/components/hook-form';
import HttpServices from 'src/services/httpService';
import { userModuleURL } from 'src/services/urlService';
import { useToaster } from 'src/utils/toaster/toasterContext';
import * as Yup from 'yup';

export default function ResetPasswordForm({ onSent, onGetEmail }) {
  const { t: translate } = useTranslation();

  const [isSubmitting, setSubmit] = useState(false);
  const { showToast } = useToaster();
  const ResetPasswordSchema = Yup.object().shape({
    email: Yup.string()
      .email(translate('reset_password.vaild_email'))
      .required(translate('reset_password.email_required')),
  });

  const methods = useForm({
    resolver: yupResolver(ResetPasswordSchema),
    defaultValues: { email: '' },
  });

  const { handleSubmit } = methods;

  const handleResetPasswordSuccess = (data, message) => {
    message && showToast(message);
    onSent();
    onGetEmail(data.email);
  };

  const handleResetPasswordFailure = (message) => {
    message && showToast(message);
    setSubmit(false);
  };

  const onSubmit = async (data) => {
    setSubmit(true);
    let requestModel = {
      email: data.email,
    };
    let postProps = {
      url: userModuleURL.resetPassword,
      body: requestModel,
      successCallback: handleResetPasswordSuccess,
      failureCallback: handleResetPasswordFailure,
    };
    HttpServices.Post(postProps);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="email" label={translate('profile.general.email')} />

        <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={isSubmitting}>
          {translate('change_password.reset_password')}
        </LoadingButton>
      </Stack>
    </FormProvider>
  );
}
